import { createFileRoute } from '@tanstack/react-router';
import { IneligibleDetails } from '../../../layouts/IneligibleDetails/IneligibleDetails';

export const Route = createFileRoute('/$retailer/ineligible-details/$itemId')({
  component: IneligibleDetails,
});
